export function datetime(timeStamp) {
  var date = new Date(timeStamp);

  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  // return [y, m, d, h, minute, second];
}

export function payString(data) {
  //支付渠道
  switch (data) {
    case 'weixin':
      return '微信';
      break;
    case 'zhifubao':
      return '支付宝';
      break;
    case 'cash':
      return '现金';
      break;
      case 'other':
        return '其他';
        break;
      
      

    default:
      return data;
      break;
  }
}


export function paychannelString(data) {
  //支付方式
  switch (data) {
    case 'WENXIN':
      return '微信';
      break;

    case 'MAGCARD':
      return 'IC卡';
      break;
    case 'BRIDGE':
      return '结算二维码';
      break;
    
      case 'member':
      return '会员';
      break;
    
    case 'alipay':
      return '支付宝';
      break;
    case 'tianfutong':
      return '天府通';
      break;
    
    case 'prepay':
      return '预支付';
      break;

    default:
      return data;
      break;
  }
}



export function orderTypeString(data) {
  //支付渠道
  switch (data) {
    case 'bridge':
      return '移动管理端';
      break;

    default:
      return data;
      break;
  }
}

export function channelString(data) {
  //支付渠道
  switch (data) {
    case 'WENXIN':
      return '微信';
      break;

    case 'MAGCARD':
      return 'IC卡';
      break;
    
    case 'alipay':
      return '支付宝';
      break;
    case 'tianfutong':
      return '天府通';
      break;
    
    case 'prepay':
      return '预支付';
      break;

    default:
      return data;
      break;
  }
}

export function priceFilt(number) {
  var decimals = 2;
  const num = Number.parseFloat(number);
  const bit = decimals > 2 ? 2 : decimals; // 小数位数最多二位；
  let ret = '';
  if (bit >= 0) {
    ret = num.toFixed(bit);
  } else {
    ret = String(num.toFixed(2) * 1);
  }

  return ret.replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
}

export function payStateString(data) {
  //支付状态
  switch (data) {
    case 'pay_failed':
      return '支付失败';
      break;
    case 'init':
      return '未支付';
      break;
    case 'paid':
      return '已支付';
      break;
    case 'refund':
      return '申请退款';
      break;
    case 'refund_success':
      return '退款成功';
      break;
    case 'refund_reject':
      return '退款驳回';
      break;

    default:
      return data;
      break;
  }
}
